import React, { useEffect } from 'react';

const useEffectCancelled = (
  serviceFunc: (canceller: AbortController) => void | (() => void),
  deps: any[]
) => {
  useEffect(() => {
    const canceller = new AbortController();

    const unsub = serviceFunc(canceller);

    return () => {
      canceller.abort();
      if (unsub) unsub();
    };
  }, [...deps]);
};

export default useEffectCancelled;
